﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListCommPartnership extends GuiListGeneric {

    constructor() {
        super("CommPartnership");

    }

}

